import {ProductsSelect} from "@components/Products/ProductsSelect/ProductsSelect";
import {InputNumber, Row, Select, Input, Checkbox} from "antd";
import ImageUploader from "../components/Form/ImageUploader/ImageUploader";
import React from "react";
import CustomSelect from "../components/Form/CustomSelect/CustomSelect";
import AttributesSelect from "../components/Form/AttributesSelect/AttributesSelect";
import TagSelect from "../components/Form/TagSelect/TagSelect";
import ShippingDeliveryType from "../components/Form/ShippingDeliveryType/ShippingDeliveryType";
import QuillEditor from "../components/QuillEditor/QuillEditor";

const {Option} = Select;
const {TextArea} = Input;

const getComponentByType = ({
                                value,
                                formRef = null,
                                setIsChanged = false,
                                isFormItem = true,
                                isAddingForm = false}) => {

    const type = value.type;
    const options = value.options && value.options.length > 0 ? value.options : [];
    const checkboxText = value.type === 'checkbox' ? value.label: '';
    const placeholder =  value.placeholder;
    const values = formRef && formRef.current ? formRef.current.getFieldsValue() : null;

    switch (type) {
        case 'select':
            return (
                <Select>
                    {
                        options && options.length > 0 && options.map(option => {
                            return <Option key={option + '_' + Math.random()} value={option.key}>{ option.value ?? option.key}</Option>
                        })
                    }
                </Select>
            )
        case 'multiple':
            return (
                <CustomSelect
                    formItem={{isFormItem: isFormItem, name: value.name, label: value.label}}
                    type={value.fetch_type ?? value.name}
                    optionName='name' optionValue='id' />
            )
        case 'single_select':
            return (
                <CustomSelect
                    formItem={{isFormItem: isFormItem, name: value.name, label: value.label}}
                    optionName='name' optionValue='id'
                    modeType='single' type={value.fetch_type ?? value.name}/>
            )
        case 'tags':
            return (
                <Select mode='tags'/>
            )
        case 'custom_tag':
            return (
                <TagSelect initialValues={value?.tags} formRef={formRef} setIsChanged={setIsChanged}/>
            )
        case 'product_select':
            return (
                <ProductsSelect
                    form={{
                        label: value.label,
                        name: value.name,
                        ref: formRef,
                    }}
                    limit={value.limit ? value.limit : -1}
                />
            )
        case 'attribute_select':
            return (
                <AttributesSelect formRef={formRef} defaultProductAttributes={value.attributes} setIsChanged={setIsChanged}/>
            )
        case 'checkbox':
            return <Checkbox>{checkboxText}</Checkbox>
        case 'number':
            return <InputNumber placeholder={placeholder}/>
        case 'textarea':
            return <TextArea rows={4} placeholder={placeholder}/>
        case 'upload':
            return (
                <Row>
                    <ImageUploader/>
                </Row>
            )
        case 'quill':
            return (
                <QuillEditor isAcf={true} field={{name: value.name}}/>
            )
        case 'home_delivery_type':
            return (
                <ShippingDeliveryType formRef={formRef} formValues={values} isAddingForm={true}/>
            )
        default:
            return <Input name={value.name} placeholder={placeholder}/>
    }
}

export default getComponentByType;
